import styled from 'styled-components';

const NavIconItem = styled.button<{ isOpen?: boolean }>`
  padding: 6px;
  text-decoration: none;
  background-color: var(--color-bg-primary);
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 6px;
  border: none;
  transition: all 0.2s ease;

  ${(props) =>
    props.isOpen &&
    `
    background-color: var(--color-bg-tertiary);

    svg {
      color: var(--color-text-primary) !important;
    }
  `}

  &:hover {
    background-color: var(--color-bg-tertiary);
    svg {
      color: var(--color-text-primary) !important;
    }
  }
  &:focus {
    background-color: var(--color-bg-hover);
  }

  svg {
  }
`;

export default NavIconItem;
